import { type CourseState } from '@editor2/types/courseState';

export const courseToCourseProperties = (state: CourseState) => {
	return {
		book: state.book,
		chapters: state.chapters,
		page_groups: state.page_groups,
		pages: state.pages,
		elements: state.elements,
		lecture_slide_decks: state.lecture_slide_decks
	};
};
